import { LocalScheme } from '~auth/runtime'

export default class CustomScheme extends LocalScheme {
  check() { return { valid: true } }

  // adapted from https://github.com/nuxt-community/auth-module/blob/dev/src/schemes/local.ts#L126
  mounted({
    tokenCallback = () => this.$auth.reset(),
    refreshTokenCallback = undefined
  } = {}) {
    const { route: { query: { auth_token: token } } } = this.$auth.ctx
    const urlWithToken = new URL(this.options.endpoints.user.url, window.location.origin)
    urlWithToken.searchParams.set('auth_token', token)
    const { pathname, search } = urlWithToken
    const endpointWithToken = [pathname, search].join('')

    const { tokenExpired, refreshTokenExpired } = this.check(true)

    if (refreshTokenExpired && typeof refreshTokenCallback === 'function') {
      refreshTokenCallback()
    } else if (tokenExpired && typeof tokenCallback === 'function') {
      tokenCallback()
    }

    // Initialize request interceptor
    this.initializeRequestInterceptor()

    // Fetch user once
    return this.$auth.fetchUserOnce({
      ...this.options.endpoints.user,
      url: endpointWithToken
    })
  }
}
